import { useState } from "react";
import toast from "react-hot-toast";
import { Link, useNavigate,useParams } from "react-router-dom";
import { useEffect } from "react";
import axiosInstance, { weburl } from "../../../axiosInstance";
import Sidebar from "../../components/Sidebar";
import Navbar from "../../components/Navbar";
import getCookie from "../../../helpers/getCookie";
import getDecryptData from "../../../helpers/getDecryptData";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import LoadingScreen from "../../components/LoadingScreen";
import Select from "react-select";

const ProfileEdit = () => {
  
  const navigate = useNavigate();
  const [filteredCities, setFilteredCities] = useState([]);

  const [loading, setLoading] = useState(true); // Add loading state

  const [SubmitLoading, setSubmitLoading] = useState(true); // Add loading state
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);


  const [dataNew, setDataNew] = useState([]);

  const [inputs, setInputs] = useState({
    type: "",
    username: "",
    phone: "",
    email: "",
    password: "",
    confirm_password: "",
    pincode: "",
    Gender: "1",
    DOB: "",
    address: "",
    coverage: [], // this must be an array!
    department: [], // this must be an array!
  });

  const normalizeMultiValue = (value) => {
    if (Array.isArray(value)) {
      return value.map((item) => item?._id || item).filter(Boolean);
    }

    return value ? [value] : [];
  };

  // //handle input change
  // const handleChange = (e) => {
  //     const { name, value, type, checked, files } = e.target;
  //     setInputs((prevData) => ({
  //         ...prevData,
  //         [name]:
  //             type === "checkbox" ? checked : type === "file" ? files[0] : value,
  //     }));
  // };

  const capitalizeEachWord = (str) => {
    if (!str) return str;
    return str
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const CreateSlug = (str) => {
    var slug = str;

    // Convert to lowercase
    slug = slug.toLowerCase();

    // Replace spaces with hyphens
    slug = slug.replace(/\s+/g, "-");

    // Remove special characters (only allow alphanumeric, hyphens, and underscores)
    slug = slug.replace(/[^a-z0-9\-]/g, "");

    return slug;
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    let newValue;

    // Handle multi-checkbox logic
    if (type === "checkbox") {
      if (name === "OfferEquipment") {
        // If 'specialization' is being updated, add/remove values from the array
        newValue = checked
          ? [...(inputs.OfferEquipment || []), value] // Add value if checked
          : (inputs.OfferEquipment || []).filter((item) => item !== value); // Remove value if unchecked
      } else if (name === "NatureOfBusiness") {
        // If 'specialization' is being updated, add/remove values from the array
        newValue = checked
          ? [...(inputs.NatureOfBusiness || []), value] // Add value if checked
          : (inputs.NatureOfBusiness || []).filter((item) => item !== value); // Remove value if unchecked
      } else {
        newValue = checked;
        console.log(type, name, newValue);
      }
    } else if (type === "file") {
      // Handle file input
      newValue = files[0];
    } else {
      // Handle normal text inputs
      newValue = value;
    }

    // Capitalize text for the 'username' field
    if (name === "state") {
      const selectedState = data.find((state) => state._id === newValue);
      if (selectedState) {
        setFilteredCities(selectedState.cities);
        setInputs((prevData) => ({
          ...prevData,
          statename: selectedState.name,
          city: "",
        }));
      }
      console.log("selectedState", selectedState, newValue, data);
    }

    if (name === "coverage") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.coverage) ? inputs.coverage : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          coverage: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
    if (name === "department") {
      const value = e.target.value;
    
      const selected = [...(Array.isArray(inputs.department) ? inputs.department : [])];
    
      if (!selected.includes(value)) {
        selected.push(value);
    
        setInputs((prev) => ({
          ...prev,
          department: selected,
        }));
    
        console.log("selected", selected); // ✅ shows correct array
      }
      return null;
    }
    
    // Capitalize the text for 'username' field
    if (name === "username") {
      newValue = capitalizeEachWord(newValue);
      // Update the state with the new value
      setInputs((prevData) => ({
        ...prevData,
        profile_url: CreateSlug(newValue),
      }));
    }

    // Capitalize the text for 'username' field
    if (name === "profile_url") {
      newValue = CreateSlug(newValue);
    }

    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      [name]: newValue,
    }));
  };

  const removeCoverage = (cityToRemove) => {
    setInputs((prev) => ({
      ...prev,
      coverage: prev.coverage.filter((c) => c !== cityToRemove),
    }));
  };

  const removeDepartment = (departmentId) => {
    // Remove the department from the array
    setInputs({
      ...inputs,
      department: inputs.department.filter(id => id !== departmentId),
    });
  };

  const departmentOptions = data2.map((item) => ({
    value: item._id,
    label: item.title,
  }));

  const selectedDepartmentOptions = departmentOptions.filter((option) =>
    normalizeMultiValue(inputs.department).includes(option.value)
  );

  const handleDepartmentSelectChange = (selectedOptions) => {
    setInputs((prev) => ({
      ...prev,
      department: (selectedOptions || []).map((option) => option.value),
    }));
  };
  

  const [showPassword, setShowPassword] = useState(false);

  const handleDescriptionChange = (value) => {
    // Update the state with the new value
    setInputs((prevData) => ({
      ...prevData,
      about: value,
    }));
  };

  // Function to toggle password visibility
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  //form handle
  const fetchUserById = async () => {
    const decryptdatajson = await getDecryptData();
    const id = decryptdatajson?._id;

    const credentials = {
      id: id,
    };

    try {
      const { data } = await axiosInstance.post("/auth-user", credentials);
      const { success, token, existingUser, message } = data;

      if (success) {
        setInputs((prevData) => ({
          ...prevData,
          username: existingUser.username || "",
          phone: existingUser.phone || "",
          email: existingUser.email || "",
          address: existingUser.address || "",
          pincode: existingUser.pincode || "",
          state: existingUser.state || "",
          statename: existingUser.statename || "",
          country: existingUser.country || "",
          city: existingUser.city || "",
          about: existingUser.about || "",
          department: normalizeMultiValue(existingUser.department),
          Doc1: existingUser.Doc1 || "",
          Doc2: existingUser.Doc2 || "",
          Doc3: existingUser.Doc3 || "",
          profile: existingUser.profile || "",
          aadharno: existingUser.aadharno || "",
          pHealthHistory: existingUser.pHealthHistory || "",
          cHealthStatus: existingUser.cHealthStatus || "",
          coverage: existingUser.coverage || [],
        }));
      }

      console.log("success", existingUser);
    } catch (error) {
      console.error("Error during login:", error);
      // Handle network errors, API issues, etc.
      toast.error(error.response.data.message);
    }
  };

  useEffect(() => {
    fetchUserById();
  }, []);

  const handleSubmit = async () => {
    const decryptdatajson = await getDecryptData();

    const id = decryptdatajson?._id;

    setSubmitLoading(false);
    console.log(inputs);
    const fields = [
      { name: "username", message: "Please enter Full Name" },
      { name: "phone", message: "Please enter phone number" },
      { name: "email", message: "Please enter email" },
      // { name: "department", message: "Please choose department" },
      // { name: "coverage", message: "Please choose coverage area" },

      
      // { name: "Gender", message: "Please enter Gender" },
      // { name: "DOB", message: "Please enter DOB" },
      // { name: "state", message: "Please enter State" },
      // { name: "pincode", message: "Please enter pincode" },
      // { name: "address", message: "Please enter address" },
      // { name: "profile", message: "Please choose profile photo" },
      // {
      //   name: "AadhaarFront",
      //   message: "Please choose Aadhaar Front photo ",
      // },
      // {
      //   name: "AadhaarBack",
      //   message: "Please choose Aadhaar Back photo ",
      // },
    ];

    for (const field of fields) {
      if (!inputs[field.name]) {
        toast.error(field.message);
       setSubmitLoading(true);
        return null;
      }
    }
    if(inputs.department.length === 0){
      toast.error('Please choose department');
      setSubmitLoading(true);
      return null;
    } 
    if(inputs.coverage.length === 0){
      toast.error('Please choose coverage area');
      setSubmitLoading(true);
      return null;
    }


    console.log("inputsinputs", inputs);
    try {
      const { data } = await axiosInstance.put(
        `/update-user-vendor/${id}`,
        inputs,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );
      const { success } = data;
      if (success) {
        // navigate("/");

        toast.success("Account Updated Successfully  ");
      }
    } catch (error) {
      console.error("Error On Signup:", error);
      toast.error(error.response.data.message);
    } finally {
      setSubmitLoading(true);
    }
  };

  const fetchData = async () => {
    setLoading(true);
    console.log("response.data start");

    try {
      const response = await axiosInstance.get("/get-all-zones-category");
      console.log("response.data.Zones,", response.data.Zones);
      setData(response.data.Zones || []);
      setData2(response.data.Categories || []);

    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };





  useEffect(() => {
    fetchData();
  }, []);

  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const handleSidebarToggle = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <>
      <Sidebar />
      <main className="content">
        <Navbar />




        <div className="py-4">
          <div className="d-flex justify-content-between w-100 flex-wrap">
            <div className="container pt-0">
              <div
                className="dashboard-content px-4 py-3 "
                style={{ maxWidth: "100vw" }}
              >
                <div className="col-md-6">
                  <label className="mb-4   h4">Update Profile </label>
                </div>
                {loading ? <LoadingScreen /> :
                  <form className="m-b20 row">
                    <div className="card  border-0 bg-white p-4 mb-4">
                      <div className="row">

                        <div className="mb-4">
                          <label className="form-label text-dark" htmlFor="name">
                            Full Name{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type="text"
                              id="username"
                              className="form-control"
                              name="username"
                              value={inputs.username}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="email">
                            Email{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              readOnly
                              type="email"
                              id="email"
                              className="form-control"
                              name="email"
                              value={inputs.email}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6">
                          <label className="form-label text-dark" htmlFor="phone">
                            Phone{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              readOnly
                              type="email"
                              id="phone"
                              className="form-control"
                              name="phone"
                              value={inputs.phone}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label
                            className="form-label text-dark"
                            htmlFor="Gender"
                          >
                            Gender{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              value={inputs.Gender}
                              name="Gender"
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                Select Gender
                              </option>
                              <option value="1">Male</option>
                              <option value="2">Female</option>
                              <option value="0">Other</option>
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            State{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="state"
                              name="state"
                              value={inputs.state}
                              onChange={handleChange}
                            >
                              <option selected disabled>
                                {" "}
                                {loading ? "Loading..." : "Select State"}
                              </option>
                              {data.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.name}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>

                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="city">
                            City{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <select
                              className="form-control"
                              id="city"
                              name="city"
                              value={inputs.city}
                              onChange={handleChange}
                            >
                              <option selected value={""} disabled>
                                {" "}
                                {!inputs.city ? "Select City" : inputs.city}
                              </option>
                              {filteredCities.map((city, index) => (
                                <option key={index} value={city}>
                                  {city}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>
                        </div>
 
 <hr/>

   {/* Multi Select for Coverage */}
   <div className="mb-2 col-12">
        <label className="form-label text-dark" htmlFor="coverage">
          Coverage Areas <span className="text-muted">(Multi Select)</span>
        </label>
        <div className="input-group input-sm">
          <select
            className="form-control"
            id="coverage"
            name="coverage"
         onChange={handleChange}
         selected={inputs.coverage}
         value={'null'}
            
          >
            <option value="null" selected>
              Select Coverage Area
            </option>
            {filteredCities.map((city, index) => (
              <option key={index} value={city}>
                {city}
              </option>
            ))}
          </select>
        </div>
        </div>
        <div className="mb-4">
  {Array.isArray(inputs.coverage) && inputs.coverage.length > 0 ? (
    inputs.coverage.map((city, index) => (
      <span
        key={index}
        className="badge bg-primary me-1"
        style={{ cursor: "pointer" }}
        onClick={() => removeCoverage(city)}
        title="Click to remove"
      >
        {city} ×
      </span>
    ))
  ) : (
    <span className="text-muted">No coverage cities selected.</span>
  )}
</div>



                        <div className="mb-4 col-6  ">
                          <label className="form-label text-dark" htmlFor="aadharno">
                            Pincode
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <input
                              type="number"

                              id="pincode"
                              className="form-control custom-date"
                              name="pincode"
                              value={inputs.pincode}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="password"
                              value={inputs.password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>
                        <div className="mb-4 col-md-6">
                          <label
                            className="form-label text-dark"
                            htmlFor="password"
                          >
                            New Confirm Password{" "}
                          </label>
                          <div className="input-group   input-sm">
                            <input
                              type={showPassword ? "text" : "password"}
                              id="password"
                              className="form-control dz-password"
                              name="confirm_password"
                              value={inputs.confirm_password}
                              onChange={handleChange} // Add onChange handler to manage input changes
                            // onKeyPress={(e) => {
                            //   if (e.key === 'Enter' && inputs.phone.length === 10) {
                            //     submitLoginPass();
                            //   }
                            // }}
                            />
                            <span className="input-group-text text-primary p-1">
                              {/* Toggle password visibility button */}
                              <i
                                className={
                                  showPassword
                                    ? "ri-eye-off-fill cursor"
                                    : "ri-eye-fill cursor"
                                }
                                onClick={togglePasswordVisibility}
                              />
                            </span>
                          </div>
                        </div>



                        <div className="mb-4 col-6 ">
                          <label className="form-label text-dark" htmlFor="email">
                            Department{" "}
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <Select
                            inputId="department"
                            name="department"
                            isMulti
                            isSearchable
                            closeMenuOnSelect={false}
                            options={departmentOptions}
                            value={selectedDepartmentOptions}
                            onChange={handleDepartmentSelectChange}
                            placeholder="Search and select departments"
                          />
                          <div className="input-group input-sm d-none">
                            <select
                              className="form-control"
                              id="department"
                              name="department"
                              value={'null'}
                              onChange={handleChange}
                            >
                              <option >
                                 Select departments
                              </option>
                              {data2.map((item) => (
                                <option key={item._id} value={item._id}>
                                  {item.title}
                                </option>
                              ))}{" "}
                              ;
                            </select>
                          </div>

                          <div className="mb-4 d-none">
  {Array.isArray(inputs.department) && inputs.department.length > 0 ? (
    inputs.department.map((departmentId, index) => {
      const department = data2.find(item => item._id === departmentId);  // Find the department by its ID
      return department ? (
        <span
          key={index}
          className="badge bg-primary me-1"
          style={{ cursor: "pointer" }}
          onClick={() => removeDepartment(departmentId)}
          title="Click to remove"
        >
          {department.title} ×  {/* Display the department title */}
        </span>
      ) : null;
    })
  ) : (
    <span className="text-muted">No coverage cities selected.</span>
  )}
</div>


                        </div>


                        <div className="mb-4 col-12  ">
                          <label className="form-label text-dark" htmlFor="email">
                            Address
                            <span className="text-danger"> ( Required )</span>
                          </label>
                          <div className="input-group    input-sm">
                            <textarea
                              id="pincode"
                              className="form-control custom-date"
                              name="address"
                              value={inputs.address}
                              onChange={handleChange}
                            />
                          </div>
                        </div>

                      

                         <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="profileImage">
                                                  Profile Image
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                        {inputs.profile && typeof inputs.profile === "string" ? (
                          <img
                            src={inputs.profile !== "" ? weburl + inputs.profile : "/img/profile-default.png"}
                            id="ProfileImage"
                            alt="Profile Image"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: "",
                              objectFit: "cover",
                              border: "1px solid grey",
                            }}
                          />
                        ) : (
                          <img
                            src={inputs.profile && typeof inputs.profile === "string" && inputs.profile !== "" 
                              ? weburl + inputs.profile 
                              : "/img/profile-default.png"}
                            id="ProfileImage"
                            alt="Profile Image"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: "",
                              objectFit: "cover",
                              border: "1px solid grey",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          id="profileImage"
                          className="form-control"
                          name="profileImage"
                          accept=".jpg, .jpeg, .png, .webp"
                          onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = (e) => {
                                const imgElement = document.getElementById("ProfileImage");
                                if (imgElement) {
                                  imgElement.src = e.target.result; // Set the image URL directly on the img element
                                }
                              };
                              reader.readAsDataURL(file); // Read the file as a data URL
                              setInputs((prevData) => ({ ...prevData, profile: file })); // Update profile in state
                            }
                          }}
                        />
                      </div>
                      
                                              </div>
                      
                      
                      
                                              <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="Doc1">
                                                  Document 1
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                        {inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1.indexOf(".pdf") !== -1 ? (
                          <embed
                            src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
                            id="LicensingImage"
                            alt="Document 1"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: 5,
                              objectFit: "contain",
                              border: "1px solid grey",
                            }}
                          />
                        ) : (
                          <img
                            src={inputs.Doc1 && typeof inputs.Doc1 === "string" && inputs.Doc1 !== "" ? weburl + inputs.Doc1 : "/img/imageupload.png"}
                            id="LicensingImage"
                            alt="Document 1"
                            style={{
                              width: "100%",
                              aspectRatio: "1/1",
                              background: "#f8f9fa",
                              display: "block",
                              textAlign: "center",
                              lineHeight: "40vh",
                              borderRadius: 5,
                              objectFit: "contain",
                              border: "1px solid grey",
                            }}
                          />
                        )}
                        <input
                          type="file"
                          id="Doc1"
                          className="form-control"
                          name="Doc1"
                          accept=".jpg, .jpeg, .png, .pdf, .webp"
                          onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                              const reader = new FileReader();
                              reader.onload = (e) => {
                                const imgElement = document.getElementById("LicensingImage");
                                if (imgElement) {
                                  var computedStyle = window.getComputedStyle(imgElement);
                                  var allStyles = "";
                                  for (var i = 0; i < computedStyle.length; i++) {
                                    var styleProperty = computedStyle[i];
                                    allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                  }
                      
                                  var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                  iframe.src = e.target.result;
                                  iframe.style.cssText = allStyles;
                                  iframe.style.border = "none";
                                  iframe.id = imgElement.id;
                                  imgElement.parentNode.replaceChild(iframe, imgElement);
                                }
                              };
                              reader.readAsDataURL(file);
                              setInputs((prevData) => ({ ...prevData, Doc1: file }));
                            }
                          }}
                        />
                      </div>
                      
                      
                                              </div>
                      
                                              {/* Duplicate for Doc2 */}
                                              <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="Doc2">
                                                  Document 2
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                                                  {inputs.Doc2 && typeof inputs.Doc2 === "string" && inputs.Doc2.indexOf(".pdf") !== -1 ? (
                                                    <embed
                                                      src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                                      id="LicensingImage2"
                                                      alt="Document 2"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={inputs && inputs.Doc2 !== "" ? weburl + inputs.Doc2 : "/img/imageupload.png"}
                                                      id="LicensingImage2"
                                                      alt="Document 2"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  )}
                                                  <input
                                                    type="file"
                                                    id="Doc2"
                                                    className="form-control"
                                                    name="Doc2"
                                                    accept=".jpg, .jpeg, .png, .pdf, .webp"
                                                    onChange={(event) => {
                                                      const file = event.target.files[0];
                                                      if (file) {
                                                        const reader = new FileReader();
                                                        reader.onload = (e) => {
                                                          const imgElement = document.getElementById("LicensingImage2");
                                                          if (imgElement) {
                                                            var computedStyle = window.getComputedStyle(imgElement);
                                                            var allStyles = "";
                                                            for (var i = 0; i < computedStyle.length; i++) {
                                                              var styleProperty = computedStyle[i];
                                                              allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                                            }
                      
                                                            var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                                            iframe.src = e.target.result;
                                                            iframe.style.cssText = allStyles;
                                                            iframe.style.border = "none";
                                                            iframe.id = imgElement.id;
                                                            imgElement.parentNode.replaceChild(iframe, imgElement);
                                                          }
                                                        };
                                                        reader.readAsDataURL(file);
                                                        setInputs((prevData) => ({ ...prevData, Doc2: file }));
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </div>
                      
                                              {/* Duplicate for Doc3 */}
                                              <div className="mb-4 col-6 col-md-3">
                                                <label className="form-label text-dark" htmlFor="Doc3">
                                                  Document 3
                                                  <span className="text-danger"> ( Required )</span>
                                                </label>
                      
                                                <div className="openimage-container">
                                                  {inputs.Doc3 && typeof inputs.Doc3 === "string" && inputs.Doc3.indexOf(".pdf") !== -1 ? (
                                                    <embed
                                                      src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                                      id="LicensingImage3"
                                                      alt="Document 3"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  ) : (
                                                    <img
                                                      src={inputs && inputs.Doc3 !== "" ? weburl + inputs.Doc3 : "/img/imageupload.png"}
                                                      id="LicensingImage3"
                                                      alt="Document 3"
                                                      style={{
                                                        width: "100%",
                                                        aspectRatio: "1/1",
                                                        background: "#f8f9fa",
                                                        display: "block",
                                                        textAlign: "center",
                                                        lineHeight: "40vh",
                                                        borderRadius: 5,
                                                        objectFit: "contain",
                                                        border: "1px solid grey",
                                                      }}
                                                    />
                                                  )}
                                                  <input
                                                    type="file"
                                                    id="Doc3"
                                                    className="form-control"
                                                    name="Doc3"
                                                    accept=".jpg, .jpeg, .png, .pdf, .webp"
                                                    onChange={(event) => {
                                                      const file = event.target.files[0];
                                                      if (file) {
                                                        const reader = new FileReader();
                                                        reader.onload = (e) => {
                                                          const imgElement = document.getElementById("LicensingImage3");
                                                          if (imgElement) {
                                                            var computedStyle = window.getComputedStyle(imgElement);
                                                            var allStyles = "";
                                                            for (var i = 0; i < computedStyle.length; i++) {
                                                              var styleProperty = computedStyle[i];
                                                              allStyles += `${styleProperty}: ${computedStyle.getPropertyValue(styleProperty)}; `;
                                                            }
                      
                                                            var iframe = document.createElement(file.type.indexOf("pdf") !== -1 ? "iframe" : "img");
                                                            iframe.src = e.target.result;
                                                            iframe.style.cssText = allStyles;
                                                            iframe.style.border = "none";
                                                            iframe.id = imgElement.id;
                                                            imgElement.parentNode.replaceChild(iframe, imgElement);
                                                          }
                                                        };
                                                        reader.readAsDataURL(file);
                                                        setInputs((prevData) => ({ ...prevData, Doc3: file }));
                                                      }
                                                    }}
                                                  />
                                                </div>
                                              </div>
                      
                      


                        <div className="mb-4 col-12">
                          <label className="form-label text-dark" htmlFor="email">
                            About
                            <span className="text-danger"> ( Required )</span>
                          </label>

                          <ReactQuill
                            value={inputs.about}
                            onChange={handleDescriptionChange}
                            modules={{
                              toolbar: [
                                [
                                  "bold",
                                  "italic",
                                  "underline",
                                  "strike",
                                  "blockquote",
                                ],
                                [{ list: "ordered" }, { list: "bullet" }],
                              ],
                            }}
                            formats={[
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                              "list",
                              "bullet",
                            ]}
                            bounds={".app"}
                          />
                        </div>



                      </div>
                    </div>

                    <div className="col-md-12 text-end">
                      {SubmitLoading ? (
                        <button
                          className="btn btn-gray-800 d-inline-flex align-items-center justify-content-center mb-4 ms-auto"
                          type="button"
                          onClick={handleSubmit}
                           
                        >
                          Update Profile
                        </button>
                      ) : (
                        <button
                          disabled
                          className="btn btn-gray-800 d-inline-flex align-items-center justify-content-center mb-4"
                          type="button"
                        >
                          <span className="ms-1">Loading...</span>
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        </button>
                      )}
                    </div>
                  </form>
                }





              </div>
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default ProfileEdit;
